import { render, staticRenderFns } from "./PromocaoParceiro.vue?vue&type=template&id=64c1093f&"
import script from "./PromocaoParceiro.vue?vue&type=script&lang=js&"
export * from "./PromocaoParceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports